import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to AsyncStorage for react-native
import thunkMiddleware from 'redux-thunk';
import reducers from '../reducers';
import { RUNTIME_ENVIRONMENT } from '../utils/Environment';

if (RUNTIME_ENVIRONMENT === 'production') {
  console.log = () => {};
}

const loggerMiddleware = createLogger({ predicate: (getState, action) => process.env.NODE_ENV === `development` }); //logger only works in DEV mode
const persistConfig = {
  key: 'root',
  storage,
};
const persistedReducer = persistReducer(persistConfig, reducers);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState) {
  const enhancer = composeEnhancers(applyMiddleware(thunkMiddleware, loggerMiddleware));
  let store = createStore(persistedReducer, initialState, enhancer);
  return store;
}
